import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

export default function BackButton({ onClick, label, className = '' }: BackButtonProps) {
  const base = label
    ? 'flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:text-foreground rounded-full border border-border bg-background hover:bg-muted/40 shadow-xs transition-all'
    : 'flex items-center justify-center p-2 text-sm text-muted-foreground hover:text-foreground rounded-full border border-border bg-background hover:bg-muted/40 shadow-xs transition-all';

  return (
    <button type="button" onClick={onClick} className={`${base} ${className}`}>
      <ArrowLeft className="w-4 h-4" />
      {label && <span>{label}</span>}
    </button>
  );
}
